import { useContext, useEffect, useLayoutEffect, useState } from 'react';
import { updateAppBar } from 'Utils/webviewHandlers';
import { IAppBarConfig } from 'interfaces';
import Cookies from 'js-cookie';
import { isClient } from '@/utils/common';
import { DeviceContext } from '@/pages/_app';

export const isNativeAppbarEnabled = () =>
    Boolean(Cookies.get('native_header_height'));

const useIsomorphicLayoutEffect = isClient() ? useLayoutEffect : useEffect;

export const useIsNativeAppbar = (): boolean => {
    const { isNativeAppbar } = useContext(DeviceContext);
    const [isEnabled, setIsEnabled] = useState<boolean>(isNativeAppbar);

    useIsomorphicLayoutEffect(() => {
        setIsEnabled(isNativeAppbarEnabled());
    }, []);

    return isEnabled;
};

export const useAppBarUpdate = (
    config: IAppBarConfig,
    enabled: boolean = true,
    isPageConfig: boolean = true
) => {
    useEffect(() => {
        if (!enabled) return;

        if (isNativeAppbarEnabled()) {
            updateAppBar(config, isPageConfig);
        }
    }, [config, enabled, isPageConfig]);
};
